const InkFinder = (() => {
  let currentSearchResults = {};
  let currentResultsPage = 0;
  const resultsPerPage = 24;

  const toggleThrobber = (state = 'on') => {
    const throbber = document.getElementById('spinner');

    if (throbber) {
      if (state === 'on') {
        throbber.classList.add('show');
      } else {
        throbber.classList.remove('show');
      }
    }
  };

  const getDefaultOption = () => {
    const defaultOption = document.createElement('option');
    defaultOption.text = selectionDefaultText;
    return defaultOption;
  };

  const buildPrintersList = data => {
    const machineMakerSelect = document.getElementById('machineMaker');
    const typeMachSSelect = document.getElementById('typeMachS');
    const thirdSelect = document.getElementById('thirdSelect');
    const defaultOption = getDefaultOption();
    machineMakerSelect.add(defaultOption.cloneNode(true));
    typeMachSSelect.add(defaultOption.cloneNode(true));
    thirdSelect.add(defaultOption);

    for (const machineMaker in data) {
      const option = document.createElement('option');
      option.text = machineMaker; //option.value = formatOptionValue(machineMaker);

      machineMakerSelect.add(option);
    }

    machineMakerSelect.addEventListener('change', () => {
      const selectedMachineMaker = machineMakerSelect.value;
      typeMachSSelect.innerHTML = '';
      thirdSelect.innerHTML = '';
      typeMachSSelect.add(defaultOption.cloneNode(true));
      thirdSelect.add(defaultOption.cloneNode(true));

      if (selectedMachineMaker) {
        const typeMachSArray = data[selectedMachineMaker];

        for (const typeMachS in typeMachSArray) {
          const option = document.createElement('option');
          option.text = typeMachS; //option.value = formatOptionValue(typeMachS);

          typeMachSSelect.add(option);
        }
      }
    });
    typeMachSSelect.addEventListener('change', () => {
      const selectedMachineMaker = machineMakerSelect.value;
      const selectedTypeMachS = typeMachSSelect.value;
      sendAjaxRequest(selectedMachineMaker, selectedTypeMachS);
    });
  }; // Function to send the AJAX request


  const sendAjaxRequest = (machineMaker, typeMachS) => {
    const defaultOption = getDefaultOption();
    let url = printerURLs[machineMaker][typeMachS];
    fetch(url).then(response => response.json()).then(data => {
      let cartridges = {};

      for (const value of data) {
        if (!cartridges[value['MachineModel OEM']]) {
          cartridges[value['MachineModel OEM']] = [];
        }

        cartridges[value['MachineModel OEM']].push(value.VOWCode);
      }

      thirdSelect.innerHTML = '';
      thirdSelect.add(defaultOption.cloneNode(true));

      for (const c in cartridges) {
        const value = cartridges[c];
        const option = document.createElement('option');
        option.text = c;
        option.value = value;
        thirdSelect.add(option);
      }
    }).catch(error => {
      console.error('Error:', error);
      displayErrorMessage(error.toString());
    });
  };

  const submitAPISearch = async form => {
    let url = searchAPIendpoint;
    var payload = {
      channel_code: 'ah'
    };
    let queryValue = '';
    const queryField = form.querySelector('[name="inkquery"]');

    if (queryField) {
      if (queryField.value !== selectionDefaultText) {
        queryValue = queryField.value;
      }
    }

    if (form.id == 'search-by-cartridge') {
      payload.cartridge_number = queryValue;
    } else if (form.id == 'search-by-printer') {
      payload.printer_name = queryValue;
    } else if (form.id == 'search-by-cartridge-or-printer') {
      if (queryValue) {
        payload.cartridge_number = queryValue;
      } else {
        const queryField_general = form.querySelector('[name="inkquery_general"]');

        if (queryField_general) {
          queryValue = queryField_general.value;
          payload.printer_name = queryValue;
        }
      }
    } else if (form.id == 'search-by-model') {
      if (queryValue) {
        payload.cartridge_number = queryValue.split(',');
      } else {
        // TODO: if third parameter not available, perform a generic search using 1st and 2nd parameters instead
        const printerName = form.querySelector('#machineMaker'); // conso

        queryValue = [];

        if (printerName && printerName.value && printerName.value !== selectionDefaultText) {
          queryValue.push(printerName.value);
        }

        const printerType = form.querySelector('#typeMachS');

        if (printerType && printerType.value && printerType.value !== selectionDefaultText) {
          let printerTypeText = printerType.value;
          printerTypeText = printerTypeText.replace(/ printer/gi, '');
          queryValue.push(printerTypeText);
        }

        if (queryValue) {
          payload.printer_name = queryValue;
        }
      }
    }

    if (!queryValue) {
      toggleThrobber('off');
      displayErrorMessage('Please enter a search query');
      return;
    } // GET version
    // const searchRequest = await fetch( url + '?' + new URLSearchParams(payload).toString() )


    await fetch(url, {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(payload)
    }).then(response => response.json()).then(data => {
      if (!data) {
        toggleThrobber('off');
        displayErrorMessage('Did not get expected response from API');
      }

      if (!data.success) {
        toggleThrobber('off');
        displayErrorMessage('API returned an unexpected error');
      }

      if (data.response.length > 0) {
        currentSearchResults = data.response;
        displayPageOfResults(currentSearchResults, currentResultsPage);
      } else {
        toggleThrobber('off');
        displayErrorMessage('API returned 0 results for your search');
      }
    }).catch(error => {
      console.error('Error:', error);
      toggleThrobber('off');
      displayErrorMessage(error.toString());
    });
  };

  const displayErrorMessage = message => {
    const inkFinderErrorPane = document.querySelectorAll('#inkfinder_error_pane');

    if (inkFinderErrorPane != null) {
      inkFinderErrorPane.forEach(s => {
        s.innerHTML = message;
      });
    }
  };

  const clearResults = () => {
    const inkFinderProductSSection = document.querySelectorAll('.section-ink-finder-products');

    if (inkFinderProductSSection != null) {
      inkFinderProductSSection.forEach(s => {
        s.innerHTML = '';
      });
    }

    const inkFinderErrorPane = document.querySelectorAll('#inkfinder_error_pane');

    if (inkFinderErrorPane != null) {
      inkFinderErrorPane.forEach(s => {
        s.innerHTML = '';
      });
    }
  };

  const displayPageOfResults = (currentData, page) => {
    let handles = [];
    let section = '';
    let sectionId = '';
    const inkFinderProductSSection = document.querySelectorAll('.section-ink-finder-products');

    if (inkFinderProductSSection != null) {
      inkFinderProductSSection.forEach(s => {
        section = s;
        sectionId = section.id;
        sectionId = sectionId.replace('shopify-section-', '');
      });
    }

    let startPagination = 0;
    let endPagination = resultsPerPage;
    const paginationWrapper = document.createElement('div');

    if (page > 0) {
      startPagination = resultsPerPage * page;
      endPagination = startPagination + resultsPerPage; // if (endPagination > currentData.length) {
      //     endPagination = currentData.length;
      // }
    }

    for (let i = startPagination; i < endPagination; i++) {
      const product = currentData[i];

      if (product) {
        handles.push(product.handle);
      }
    }

    paginationWrapper.classList.add('inkfinder-pagination');

    if (currentData.length > resultsPerPage) {
      for (let p = i = 0; i < currentData.length; i += resultsPerPage) {
        const paginationItem = document.createElement('button');
        paginationItem.classList.add('inkfinder-pagination-item');
        paginationItem.setAttribute('type', 'button');

        if (page == p) {
          paginationItem.classList.add('current-page');
        }

        paginationItem.innerText = p + 1;
        paginationItem.dataset.pageValue = p;
        paginationWrapper.appendChild(paginationItem);
        p++;
      }
    }

    if (handles.length) {
      let url_parameter = '&pids=' + handles.toString() + '&variant=' + Math.floor(Math.random() * (1000000 - 100000) + 100000);
      fetch(window.location.pathname + '?sections=' + sectionId + '&is_ajax=1' + url_parameter).then(response => response.json()).then(responseJson => {
        let markup = responseJson[sectionId];
        const temp = document.createElement('template');
        markup = markup.trim();
        temp.innerHTML = markup;
        toggleThrobber('off');
        const html = temp.content.firstChild; // html.insertBefore(paginationWrapper, html.firstChild);

        html.appendChild(paginationWrapper.cloneNode(true));
        section.replaceWith(html);

        if (window.innerWidth < 768) {
          const scrolltarget = document.querySelector('#inkfinder_error_pane');

          if (scrolltarget) {
            window.scroll({
              top: scrolltarget.offsetTop,
              left: 0,
              behavior: 'smooth'
            });
          }
        }
      }).catch(error => {
        console.error('Error:', error);
        toggleThrobber('off');
        displayErrorMessage(error.toString());
      });
    }
  };

  const init = () => {
    window.addEventListener('load', event => {
      buildPrintersList(printerURLs);
    });
    const inkfinderForms = document.querySelectorAll('.inkfinder form');
    [...inkfinderForms].forEach(inkfinderForm => inkfinderForm.addEventListener('submit', e => {
      e.preventDefault();
      toggleThrobber('on');
      clearResults();
      e.target.closest('form');
      submitAPISearch(e.target);
      return false;
    }));
    document.addEventListener('click', event => {
      const elem = event.target;

      if (elem.classList.contains('inkfinder-pagination-item')) {
        const page = elem.dataset.pageValue;
        displayPageOfResults(currentSearchResults, page);
      }
    });
  };

  return {
    init: () => {
      init();
    }
  };
})(); // export default InkFinder;


InkFinder.init();
